// extracted by mini-css-extract-plugin
module.exports = {"header":"_8a9813f","tickIcon":"_b839413"};